module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-beleuchtung-e8f2cee493e2a1be73f4ea0cd062e45f.svg";